const lsZoomKey = 'zoom-value';
const MIN_ZOOM = 25;
const MAX_ZOOM = 200;
const DEFAULT_ZOOM = 110;
const PORTABLE_ZOOM_SELECTOR = '.PortableLayout, .v2-portable';
const PORTABLE_SHELL_SELECTOR = '.v2-portable-shell';

export const PORTABLE_ZOOM_ROOT_SELECTOR = PORTABLE_ZOOM_SELECTOR;

function readStoredZoom() {
  const stored = localStorage.getItem(lsZoomKey);
  if (!stored) {
    return DEFAULT_ZOOM;
  }

  const parsed = Number(stored);
  if (!Number.isFinite(parsed)) {
    return DEFAULT_ZOOM;
  }

  return Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, parsed));
}

export function resetPageZoom() {
  document.body.style.zoom = '';
  document.body.style.overflow = '';
}

export function resetDocumentZoom() {
  resetPageZoom();

  document
    .querySelectorAll(`${PORTABLE_ZOOM_SELECTOR}, ${PORTABLE_SHELL_SELECTOR}`)
    .forEach((node) => {
      (node as HTMLElement).style.zoom = '';
    });
}

export function readPortableZoomPercent() {
  return readStoredZoom();
}

export function readStoredPortableZoom() {
  return readStoredZoom();
}

export function writeStoredPortableZoom(value: number) {
  localStorage.setItem(lsZoomKey, value.toString());
}

export const portableZoomLimits = {
  min: MIN_ZOOM,
  max: MAX_ZOOM,
  step: 2,
  defaultValue: DEFAULT_ZOOM,
};
